export default __webpack_public_path__ + "static/media/logo.ad3f2280.svg";